import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { EDeviceType } from '../../types/device';
import { getTextRect } from '../../../browser/utils/text';
import { Responsive } from '../Responsive';
import * as styles from './styles.css';
export var ETooltipSize;

(function (ETooltipSize) {
  ETooltipSize[ETooltipSize["S"] = 0] = "S";
  ETooltipSize[ETooltipSize["M"] = 1] = "M";
})(ETooltipSize || (ETooltipSize = {}));

export var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "hideTimeout", 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      tooltipWidth: 0,
      tooltipLeft: 0,
      arrowTop: 4,
      isHidden: false
    });

    _defineProperty(_assertThisInitialized(_this), "calculatePosition", function (props) {
      // eslint-disable-next-line react/no-find-dom-node
      var node = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var containerRect = node.getBoundingClientRect();
      var textRect = props.content ? getTextRect(props.content, "".concat(styles['tooltip']).concat(props.size === ETooltipSize.M ? " ".concat(styles['tooltip--size-m']) : '')) : null;
      var arrowSize = 6;

      switch (props.size) {
        case ETooltipSize.M:
          arrowSize = 8;
          break;

        case ETooltipSize.S:
        default:
          break;
      }

      _this.setState({
        tooltipLeft: containerRect.width,
        arrowTop: textRect ? Math.min(textRect.height / 2 - arrowSize, Math.max(4, containerRect.height / 2 - arrowSize)) : _this.state.arrowTop,
        tooltipWidth: textRect ? textRect.width : _this.state.tooltipWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearHideTimeout", function () {
      if (_this.hideTimeout) {
        window.clearTimeout(_this.hideTimeout);
      }
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var content = this.props.content;

      if (content) {
        this.calculatePosition(this.props);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var content = nextProps.content;

      if (content) {
        this.calculatePosition(nextProps);
        this.setState({
          isHidden: false
        });
        var hideDelay = nextProps.hideDelay;

        if (hideDelay) {
          this.clearHideTimeout();
          this.hideTimeout = window.setTimeout(function () {
            return _this2.setState({
              isHidden: true
            });
          }, hideDelay);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearHideTimeout();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          content = _this$props.content,
          children = _this$props.children;
      var _this$state = this.state,
          isHidden = _this$state.isHidden,
          tooltipLeft = _this$state.tooltipLeft,
          arrowTop = _this$state.arrowTop,
          tooltipWidth = _this$state.tooltipWidth;
      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, children, content && !isHidden && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Responsive, {
        deviceType: EDeviceType.Phone
      }, /*#__PURE__*/React.createElement("div", mergeStyles(styles['tooltip'], styles['tooltip--phone'], size === ETooltipSize.M && styles['tooltip--size-m']), content)), /*#__PURE__*/React.createElement(Responsive, {
        deviceType: [EDeviceType.Tablet, EDeviceType.Desktop]
      }, /*#__PURE__*/React.createElement("div", _extends({}, mergeStyles(styles['tooltip'], size === ETooltipSize.M && styles['tooltip--size-m']), {
        style: {
          width: "".concat(tooltipWidth, "px"),
          left: "".concat(tooltipLeft, "px")
        }
      }), content, /*#__PURE__*/React.createElement("span", {
        className: styles['arrow'],
        style: {
          top: "".concat(arrowTop, "px")
        }
      })))));
    }
  }]);

  return Tooltip;
}(React.Component);

_defineProperty(Tooltip, "defaultProps", {
  size: ETooltipSize.S
});